export var DKTribunalCaseType;
(function (DKTribunalCaseType) {
    DKTribunalCaseType["DKBetalingspaakrav"] = "DK-BETALINGSPAAKRAV";
    DKTribunalCaseType["DKFogedrekvisition"] = "DK-FOGEDREKVISITION";
})(DKTribunalCaseType || (DKTribunalCaseType = {}));
//# sourceMappingURL=denmark.js.map